import styled from "styled-components";

export const Container = styled.section`

`;

export const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  height: auto;
  border-bottom: 1px solid #bbbbbb;
  
  @media screen and (max-width: 768px){
    margin-top: 10px;
  }

  > img {
    width: 100%;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 70px;
    box-shadow: 2px 3px 3px #cdcdcd;

    @media screen and (max-width: 768px){
      display: flex;
      flex-direction: column;
      padding: 10px 1rem;
      gap: 1.5rem;
      align-items: center;

      button{
        margin-bottom: 1rem;
      }
    }
  }
`;

export const ContainerTextWithImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px 100px 60px;

  @media screen and (max-width: 768px){
    display: flex;
    flex-direction: column;
    padding: 30px 1.5rem 60px;

  }
  
  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 35px auto;
    gap: 1rem;
    @media screen and (max-width: 768px){
      flex-direction: column;
      align-items: center;

      
    }

    img {
      width: 19rem;
      @media screen and (max-width: 768px){
        padding: 0 1rem;
      }

    }

    p {
      width: 60%;
      @media screen and (max-width: 768px){
        width: 100%;
        padding: 2rem 0;
      }
    }
  }
`;
export const Button = styled.a`
  border: 1px solid blue;
`; 
